import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { ZuiMaterialStackModule } from '@zerops/zui/material-stack';
import { UserDataEditFormModule } from '@zerops/zui/user-data-edit-form';
import { FormSectionModule } from '@zerops/zui/form-section';
import { ZefProgressErrorModule } from '@zerops/zef/progress-error';
import { UserDataFieldsModule } from '@zerops/zui/user-data-fields';
import { ZefScrollbarComponent } from '@zerops/zef/scrollbar';
import { ZefDialogModule } from '@zerops/zef/dialog';
import { EffectsModule } from '@ngrx/effects';
import { TranslocoModule } from '@ngneat/transloco';
import { UserDataEditDialogContainer } from './user-data-edit-dialog.container';
import { UserDataEditDialogEffect } from './user-data-edit-dialog.effect';
import { UserDataEditDialogTranslationsModule } from './user-data-edit-dialog.translations';

@NgModule({
  declarations: [ UserDataEditDialogContainer ],
  imports: [
    CommonModule,
    ZuiMaterialStackModule,
    MatTooltipModule,
    UserDataEditFormModule,
    EffectsModule.forFeature([ UserDataEditDialogEffect ]),
    FormSectionModule,
    ReactiveFormsModule,
    ZefProgressErrorModule,
    TranslocoModule,
    UserDataFieldsModule,
    ZefDialogModule,
    UserDataEditDialogTranslationsModule,
    ZefScrollbarComponent
  ],
  exports: [ UserDataEditDialogContainer ]
})
export class UserDataEditDialogModule {

}
